export default __webpack_public_path__ + "static/media/aboutTopBg.eb97eb87.png";